/**
 * Authentication configuration constants
 */

export const AUTH_CONFIG = {
  // Token refresh retry settings
  MAX_REFRESH_ATTEMPTS: 3,
  REFRESH_RETRY_DELAY_BASE: 1000, // 1 second base delay for exponential backoff
  
  // Request timeout settings
  REQUEST_TIMEOUT: 10000, // 10 seconds
  
  // Cookie settings
  COOKIE_NAMES: {
    ACCESS_TOKEN: 'mta', // moria token access
    REFRESH_TOKEN: 'mtr', // moria token refresh
    CART_ID: 'mcid', // moria cart id
    GUEST_ID: 'mgid', // moria guest id
    LOGIN_STATUS: 'mls', // moria login status
    LAST_USER: 'mlu', // moria last user
    LAST_AUTH: 'mla', // moria last auth
  },
  
  // Error messages
  ERROR_MESSAGES: {
    NETWORK_ERROR: 'Bağlantı sorunu yaşanıyor. Lütfen internet bağlantınızı kontrol edin ve tekrar deneyin.',
    SESSION_EXPIRED: 'Oturumunuzun süresi dolmuş. Lütfen tekrar giriş yapın.',
    MAX_ATTEMPTS_EXCEEDED: 'Kimlik doğrulama başarısız oldu. Lütfen tekrar giriş yapmayı deneyin.',
    AUTH_FAILED: 'Kimlik doğrulama başarısız oldu.',
    GENERAL_ERROR: 'Bir hata oluştu. Lütfen tekrar deneyin.',
  }
};

export default AUTH_CONFIG;
